import React, { useMemo } from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { REPORTS_DETAIL_MUTED_TEXT_CLASS } from "./reportsDetailTheme";
import { buildEvidenceTableRows } from "../../../utils/reportEvidenceDisplay";

const REPORT_EVIDENCE_TITLE_COLOR = "#38BBD1";
const REPORT_PRIMARY_FONT = "var(--font-primary)";

export interface ReportEvidenceValueTableProps {
  pointer: string;
  value: unknown;
}

export function ReportEvidenceValueTable({
  pointer,
  value,
}: ReportEvidenceValueTableProps): JSX.Element | null {
  const rows = useMemo(() => buildEvidenceTableRows(pointer, value), [pointer, value]);

  if (!rows.length) return null;

  return (
    <div
      data-report-evidence-table=""
      data-shadcn-data-table=""
      className="w-full min-w-0 overflow-x-auto"
    >
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead
              className="w-[38%] whitespace-nowrap text-[color:var(--brand-tropical-surf)]"
              style={{ fontFamily: REPORT_PRIMARY_FONT }}
            >
              Field
            </TableHead>
            <TableHead
              className="text-[color:var(--brand-tropical-surf)]"
              style={{ fontFamily: REPORT_PRIMARY_FONT }}
            >
              Value
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={`${row.label}-${index}`}>
              <TableCell
                data-report-evidence-body=""
                className={`align-top whitespace-nowrap font-medium text-muted-foreground ${REPORTS_DETAIL_MUTED_TEXT_CLASS}`}
                style={{ fontFamily: REPORT_PRIMARY_FONT }}
              >
                {row.label}
              </TableCell>
              <TableCell
                data-report-evidence-body=""
                className={`align-top whitespace-normal ${REPORTS_DETAIL_MUTED_TEXT_CLASS}`}
                style={{ fontFamily: REPORT_PRIMARY_FONT }}
              >
                {row.value}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
